import { render, staticRenderFns } from "./TarfHistoryLayout.vue?vue&type=template&id=63920138&scoped=true"
import script from "./TarfHistoryLayout.vue?vue&type=script&lang=ts"
export * from "./TarfHistoryLayout.vue?vue&type=script&lang=ts"
import style0 from "./TarfHistoryLayout.vue?vue&type=style&index=0&id=63920138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63920138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
